import React, { createContext, useCallback, useContext } from 'react'

import { node, string } from 'prop-types'

import { EVENT_SOURCE } from './constants'
import { trackFilterSelect, trackResetClick } from './searchPageTracker'

// The same filter content renders in the filter bar, the secondary bar and the mobile drawer, so
// the container provides the event_source and every control reports through the hooks below.
const EventSourceContext = createContext(EVENT_SOURCE.FILTER_BAR)

export function FilterTrackingProvider({ eventSource, children }) {
  return (
    <EventSourceContext.Provider value={eventSource}>
      {children}
    </EventSourceContext.Provider>
  )
}

FilterTrackingProvider.propTypes = {
  eventSource: string.isRequired,
  children: node.isRequired,
}

export const useTrackFilterSelect = () => {
  const eventSource = useContext(EventSourceContext)

  return useCallback((name, value) => {
    trackFilterSelect({ name, value, eventSource })
  }, [eventSource])
}

export const useTrackResetClick = () => {
  const eventSource = useContext(EventSourceContext)

  return useCallback(() => {
    trackResetClick({ eventSource })
  }, [eventSource])
}
